import { uuidv4 } from "../../utils/utilities";

export class GraphData {
  static colorCodes = [
    "#FFFFFF"
    // "#048A81",
    // "#06D6A0",
    // "#54C6EB",
    // "#8A89C0",
    // "#CA8DC6",
    // "#FF93B3",
    // "#FFA891",
    // "#FFCD72",
    // "#F9F871",
    // "#007482",
    // "#1E2946",
    // "#2F5744",
    // "#E33258",
    // "#D15828",
    // "#E04644",
    // "#F89200"
  ];
  static maxDepth = 1;
  static populateGraphData(jsonSchema) {
    this.maxDepth = 1;
    let legionNames = [];
    let json = jsonSchema
      ? jsonSchema
      : '{"eagleViewRequestDocument":{"1":"RFP OVERVIEW","1.1":"CONTEXT","1.2":"OVERVIEW","1.3":"LEGAL","1.3.1":"SERVICES","1.3.2":"LAWS AND REGULATIONS","1.3.3":"PERMITS AND LICENSES","1.3.4":"DISCLAIMER","2":"BUSINESS OBJECTIVES","2.1":"INTRODUCTION","2.2":"STRATEGIC OBJECTIVES OF IAMS ","2.3":"GOVERNANCE ROLE OF MOTC","3":"SCOPE OF WORK","3.1":"PROJECT PHASES","3.2":"PHASE I: ASSESSEMENT OF THE CURRENT SITUATION","3.2.1":"REVIEW AND GAP ANALYSIS","3.2.2":"ROADMAP IMPEMENTATION PLAN (RIP)","3.3":"PHASE II: SUPPLY, INSTALLATION, DEVELOPMENT, IMPLEMENTATION, TESTING AND GO ALIVE","3.3.1":"GENERAL CAPABILITIES","3.3.2":"INTEGRATION CAPABILITIES","3.3.3":"DECISION SUPPORT, KPIs AND REPORTING CAPABILITIES","3.3.4":"MOBILE/ FIELD ACCESS CAPABILITIES","3.3.5":"GIS CAPABILITIES","3.3.6":"ASSET INSPECTION AND CONDITION ANALYSIS REQUIREMENTS","3.3.7":"QA/QC CAPABILITIES","3.3.8":"DATA INTEGRATION","3.3.9":"REPORTING AND MODELLING OF OPTIONS","3.3.10":"QA/QC AND DATA VERIFICATION","3.3.11":" SOFTWARE AND PILOT TESTING","3.3.12":"OPERATIONAL SPECIFIC INFORMATION","3.3.13":"ADMINISTRATION AND SYSTEM MANAGEMENT SPECIFIC INFORMATION","3.3.14":"CYBER SECURITY REQUIREMENTS","3.4":"PHASE III: KNOWLEDGE TRANSFER AND TRAINING","3.5":"PHASE IV: SUPPORT, MAINTENANCE AND DOCUMENTATION","3.6":"PHASE V: CALL-OFF \u2013 AD-HOC ENGINEERING SERVICES","3.7":"DELIVERABLES","4":"GENERAL REQUIREMENTS & COMPLIANCE REQUIREMENTS","4.1":"GENERAL ","4.2":"SUPPORT DURING WARRANTY AND MAINTENANCE PERIODS","4.3":" SOFTWARE LICENSES AND MAINTENANCE ","4.4":"COMPLIANCE REQUIREMENTS","5":"PROJECT MANAGEMENT REQUIREMENTS","5.1":"PROJECT PLANS","5.2":"PROJECT APPROACH PLAN","5.3":"PROJECT SCHEDULING PLAN","5.4":"PROJECT ORGANIZATION PLAN","5.5":"PROJECT ISSUES & RISK MANAGEMENT PLAN","5.6":"PROJECT COMMUNICATIONS MANAGEMENT PLAN","5.7":"PROJECT QUALITY MANAGEMENT","5.8":"PROJECT PERSONNEL","5.9":"FACILITIES TO BE PROVIDED BY MoTC","5.10":" MOBILIZATION OF PROJECT TEAM","5.11":" HEALTH AND SAFETY","6":"PRICING REQUIREMENTS ","6.1":"CONTRACT/TENDER PRICE","6.2":" FEES AND PAYMENTS","6.3":"TENDER PRICES","7":"SELECTION PROCESS","7.1":"SELECTION CRITERIA ","7.2":"EVALUATION","7.3":"TENDER EVALUATION CRITERIA ","7.4":"CONTRACT AWARD","8":"ADMINISTRATIVE INFORMATION AND REQUIREMENTS","8.1":"TIMETABLE","8.2":"REQUEST FOR INFORMATION AND CONTACTS","8.3":"RESPONSES TO INQUIRIES","8.4":" BIDDER (PRIME VENDOR) / SUBCONTRACTORS (SECONDARY VENDORS)","8.5":"RFP DURATION","9":"FORMAT OF PROPOSALS","9.1":"GUIDELINES","9.2":"SUBMITTAL INSTRUCTIONS","9.3":"PROPOSAL ORGANIZATION","9.4":"COMPANY PROFILE","9.5":"INFORMATION ABOUT INDIVIDUALS AND ACCESS TO FIRM RESOURCES","9.6":"COMPENSATION","9.7":"CHANGE REQUEST FOR SERVICE AGREEMENT DRAFT","9.8":"OTHER INFORMATION ","9.9":"PROPOSAL PRESENTATION","9.10":" PROPOSAL DELIVERY","9.11":"CONDITION STATEMENT AND OFFICER\u2019s SIGNATURE","10":"ESSENTIAL TERMS AND CONDITIONS","10.1":"MOTC RIGHTS","10.2":"CONFIDENTIALITY OF INFORMATION","10.3":"PROPOSAL EXPENSES","10.4":"FORMAL AGREEMENT","10.5":"GOVERNING LAWS","10.6":"SUFFICIENCY OF PROPOSAL","11":"ANNEXES"}}';
    //json = JSON.parse(json);
    let config = json[Object.keys(json)[0]];
    let childData = [],
      mapData = {};

    for (var prop in config) {
      let obj = config[prop];
      this.setKeyData(prop, childData, obj, legionNames);
    }
    mapData = {
      id: uuidv4(),
      guid: "de7893fb-214e-4f05-9879-aad2a59aecb1",
      shortName: Object.keys(json)[0],
      fullName: null,
      depth: 0,
      isLink:false,
      inTrial:true,
      children: [],
      style: {
        background: "#FFFFFF",
      },
    };
    const translateData = {
      x: window.innerWidth / 2 - 170,
      y: window.innerHeight / 2 - 15,
    };
    return {
      graph: mapData,
      defaultZoom: this.getDefaultZoom(Object.keys(config).length),
      maxDepth: this.maxDepth,
      legionData: legionNames,
      translate: translateData,
    };
  }

  static setKeyData(dataKey, obj, value, legionNames) {
    const key = dataKey.split(".");
    const maxValue = key.length - 1;
    let addChildData = false;
    if (parseInt(key[0], 10) > this.maxDepth) {
      this.maxDepth = parseInt(key[0], 10);
    }
    for (let i = 0; i < key.length; i++) {
      let id = parseInt(key[i], 10) - 1;
      if (obj[id]) {
        if (i === id) {
          obj = obj[id].children;
        } else {
          obj = obj[id].children;
          addChildData = true;
        }
      } else {
        if (i === maxValue) {
          if (addChildData) {
            obj.push(this.getSubNodeData(value, parseInt(key[0], 10)));
            addChildData = false;
          } else {
            if (maxValue === 0) legionNames.push(value);
            obj[id] = this.getSubNodeData(value, parseInt(key[0], 10));
          }
        } else {
          obj[id] = {};
        }
      }
    }
  }

  static getSubNodeData(value, depth) {
    const shortTitle = value.length >= 25 ? this.getShortName(value) : value;
    const fullName = value.length >= 25 ? value : null;
    return {
      id: uuidv4(),
      shortName: shortTitle,
      fullName: fullName,
      depth,
      children: [],
      style: {
        border: "none",
        background: this.colorCodes[depth]
          ? this.colorCodes[depth]
          : this.colorCodes[depth % this.colorCodes.length],
      },
    };
  }

  static getShortName(name, limit) {
    return name.substr(0, limit || 25) + "..";
  }

  static getDefaultZoom(count) {
    let factor = 1;
    if (count <= 10) return factor;
    if (count < 20) {
      factor = 1;
    } else if (count < 60) {
      factor = 0.55;
    } else if (count < 100) {
      factor = 0.13;
    } else if (count < 200) {
      factor = 0.09;
    } else {
      factor = 0.04;
    }
    return factor;
  }
}
